module.exports = __webpack_public_path__ + "media/assets/certification_page/dp-6d9f2cd08db071285c6df07a831c15a7fc14c8130b4d72f1ff3a1171557e9aa4.svg";